import React, { useEffect, useState } from "react";
import { Phone, Menu as MenuIcon, X } from "lucide-react";
import { RESTAURANT } from "../data/menu";

const NAV = [
  { id: "ueber-uns", label: "Über uns" },
  { id: "speisekarte", label: "Speisekarte" },
  { id: "impressionen", label: "Impressionen" },
  { id: "oeffnungszeiten", label: "Öffnungszeiten" },
  { id: "reservierung", label: "Reservierung" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-black/80 backdrop-blur-xl border-b border-gold/20 py-3" : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between">
        <button
          onClick={() => scrollTo("hero")}
          data-testid="logo-link"
          className="flex items-center gap-3 group"
        >
          <span className="font-serif text-2xl md:text-3xl tracking-wide text-gradient-gold font-semibold">
            Poseidon
          </span>
          <span className="hidden sm:block text-xs uppercase tracking-[0.3em] text-gold/70 border-l border-gold/40 pl-3">
            Viechtach
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <button
              key={n.id}
              onClick={() => scrollTo(n.id)}
              data-testid={`nav-${n.id}`}
              className="relative text-sm tracking-wide text-white/85 hover:text-gold transition-colors after:content-[''] after:absolute after:left-0 after:-bottom-1 after:w-0 after:h-px after:bg-gold after:transition-all hover:after:w-full"
            >
              {n.label}
            </button>
          ))}
          <a
            href={`tel:${RESTAURANT.phoneTel}`}
            data-testid="header-call-button"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-gold text-black font-medium text-sm hover:bg-gold-soft transition-colors shadow-lg shadow-gold/20"
          >
            <Phone className="w-4 h-4" />
            {RESTAURANT.phone}
          </a>
        </nav>

        <button
          className="lg:hidden text-gold"
          onClick={() => setOpen((o) => !o)}
          data-testid="mobile-menu-toggle"
          aria-label="Menü öffnen"
        >
          {open ? <X size={28} /> : <MenuIcon size={28} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden absolute top-full left-0 right-0 bg-black/95 backdrop-blur-xl border-t border-gold/20 px-6 py-6 flex flex-col gap-4">
          {NAV.map((n) => (
            <button
              key={n.id}
              onClick={() => scrollTo(n.id)}
              data-testid={`mobile-nav-${n.id}`}
              className="text-left text-white/90 hover:text-gold py-2 border-b border-white/5"
            >
              {n.label}
            </button>
          ))}
          <a
            href={`tel:${RESTAURANT.phoneTel}`}
            data-testid="mobile-header-call-button"
            className="inline-flex items-center justify-center gap-2 mt-2 px-5 py-3 rounded-full bg-gold text-black font-medium"
          >
            <Phone className="w-4 h-4" />
            {RESTAURANT.phone}
          </a>
        </div>
      )}
    </header>
  );
}
